import { useMemo } from 'react';
import type { Order } from '../../types/ordering.types';
import {
  OrderListTable,
  COL_REF, COL_DATE, COL_DESC, COL_ADDED_BY, COL_EXP_DELIVERY, COL_TOTAL, COL_STATUS, COL_REQUESTER,
} from './OrderListTable';

interface Props {
  orders: Order[];
  isLoading: boolean;
  onOpenOrder: (order: Order) => void;
  search: string;
}

export function FYIQueue({ orders, isLoading, onOpenOrder, search }: Props) {
  const filtered = useMemo(() => {
    if (!search.trim()) return orders;
    const q = search.trim().toLowerCase();
    return orders.filter(o =>
      o.title.toLowerCase().includes(q) ||
      o.orderRef.toLowerCase().includes(q) ||
      o.requesterName.toLowerCase().includes(q)
    );
  }, [orders, search]);

  const columns = [
    COL_REF(), COL_DATE('orderDate'), COL_DESC(), COL_ADDED_BY(),
    COL_EXP_DELIVERY(), COL_TOTAL(), COL_STATUS(), COL_REQUESTER(),
  ];

  return (
    <div className="ord-view-content">
      <div className="info-box blue">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
        </svg>
        <span>
          <strong>FYI Queue</strong> — orders you've been added to as a viewer. Read-only — for your awareness only. No email notifications.
        </span>
      </div>

      {isLoading ? (
        <div className="ord-empty"><div className="spinner" /> Loading FYI queue…</div>
      ) : (
        <OrderListTable
          orders={filtered}
          columns={columns}
          onRowClick={onOpenOrder}
          emptyMessage="No orders in your FYI queue."
        />
      )}
    </div>
  );
}
